import { Component, ElementRef, HostBinding, Input, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  encapsulation: ViewEncapsulation.None,
  exportAs: 'fl-stepper-section',
  selector: 'fl-stepper-section',
  styleUrls: ['./stepper-section.component.scss'],
  template: '<ng-content></ng-content>'
})
export class StepperSectionComponent implements OnInit {
  @HostBinding('class.active')
  get className(): boolean {
    return this.activeSectionIndex === this.index;
  }
  @Input() label: string;
  @Input() visible: boolean;
  @Input() validationMethod: any;
  @Input() activeSectionIndex: number;
  @Input() index: number;

  constructor(public el: ElementRef) {}

  ngOnInit() {}
}
